module.exports = __webpack_public_path__ + "static/media/sweden-map-sights3.148588d0.jpg";